import { handleActions } from 'redux-actions';
import {
  appStart,
  appQuit,
  deepLinkStart,
  deepLinkQuit,
  setCurrentView,
  setNextView,
  userAutoloaded,
  deeplinkOutsidePlayer,
  allowEndDeeplinkOnBackNav,
} from './actions';

const initialState = {
  appStarted: false,
  deepLinkStarted: false,
  currentView: '',
  nextView: '',
  viewTransition: '',
  userAutoloaded: null,
  deeplinkOutsidePlayer: null,
  endDeeplinkOnBackNav: null,
};

const handleAppStart = (state = initialState) => ({
  ...state,
  appStarted: true,
});

const handleAppQuit = (state = initialState) => ({
  ...state,
  appStarted: false,
});

const handleDeepLinkQuit = (state = initialState) => ({
  ...state,
  deepLinkStarted: false,
});

const handleDeepLinkStart = (state = initialState) => ({
  ...state,
  deepLinkStarted: true,
});

const handleSetCurrentView = (state = initialState, { payload }) => ({
  ...state,
  currentView: payload,
});

const handleSetNextView = (
  state = initialState,
  { payload: { nextView, viewTransition } },
) => {
  const _curr =
    state.currentView !== state.nextView ? state.nextView : state.currentView;
  const _next = nextView;
  if (_curr === _next) {
    return {
      ...state,
    };
  }
  return {
    ...state,
    currentView: _curr,
    nextView: _next,
    viewTransition: viewTransition || '',
  };
};
const handleUserAutoloaded = (state = initialState, { payload }) => ({
  ...state,
  userAutoloaded: payload,
});

const handleDeeplinkOutsidePlayer = (state = initialState, { payload }) => ({
  ...state,
  deeplinkOutsidePlayer: payload,
});

const handleAllowEndDeeplinkOnBackNav = (
  state = initialState,
  { payload },
) => ({
  ...state,
  endDeeplinkOnBackNav: payload,
});

const reducer = handleActions(
  {
    [appStart]: handleAppStart,
    [appQuit]: handleAppQuit,
    [deepLinkQuit]: handleDeepLinkQuit,
    [deepLinkStart]: handleDeepLinkStart,
    [setCurrentView]: handleSetCurrentView,
    [setNextView]: handleSetNextView,
    [userAutoloaded]: handleUserAutoloaded,
    [deeplinkOutsidePlayer]: handleDeeplinkOutsidePlayer,
    [allowEndDeeplinkOnBackNav]: handleAllowEndDeeplinkOnBackNav,
  },
  initialState,
);

export default reducer;
